{
  "addons.addonList": "Tilleggsliste",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Opprett og hent API-nøkkel fra denne lenken",
  "addons.ambientWeatherDescription": "Ambient Værstasjon (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API-nøkkel",
  "addons.applicationKey": "Programnøkkel",
  "addons.connect": "Koble",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "V2 API Key",
  "addons.davisDescription": "Davis Værstasjon (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Hent V2 API nøkkel fra denne lenken",
  "addons.disconnect": "Koble fra",
  "addons.ecowittCreateAndRetrieveKeys": "Opprett og hent både en API-nøkkel og programnøkkel fra denne lenken",
  "addons.ecowittDescription": "Ecowitt tilbyr profesjonell wifi værstasjon, trådløs inne- og utendørs termometre, fuktighetsmåler, høypresisjonsregnmåler, luftkvalitetsmåler osv.",
  "addons.helpLink": "Slik kobler du til {provider}",
  "addons.myAcuriteAccountOnHold": "Kontoen din er satt på vent. Vennligst skriv inn passordet ditt for å koble til kontoen din på nytt",
  "addons.myAcuriteDescription": "AcuRite er det #1 værstasjonsmerket i Nord-Amerika. Som ledende innen tid, temperatur og værteknologi gir AcuRite deg detaljert informasjon om innendørs- og utendørsmiljøet ditt slik at du kan planlegge dagen med selvtillit.",
  "addons.myAcuriteEnterCredentials": "Skriv inn My AcuRite-legitimasjonen din for å koble My AcuRite-kontoen din med SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Bruk Netatmo termostaten til å endre temperaturen i hjemmet ditt fra sengen - eller fra den andre siden av kloden.",
  "addons.netatmoThermostat": "Netatmo Termostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Din personlige værstasjon",
  "addons.or": "eller",
  "addons.providerAccountDisconnected": "Tilkoblingen til værtjenesten din har utløpt. Koble til på nytt for å gjenoppta dataoppdateringer.",
  "addons.reconnect": "Koble til igjen",
  "addons.weatherflowCreateToken": "Lag og hent ditt token fra denne lenken",
  "addons.weatherflowTempestDescription": "Tempest værsystem med innebygd vind- og regnmåler",
  "addons.wundergroundApiKey": "API nøkkel",
  "addons.wundergroundDescription": "Weather Underground er et globalt fellesskap av mennesker som kobler data fra miljøsensorer som værstasjoner og luftkvalitetsmonitorer, slik at vi kan gi de rikholdige, hyperlokale dataene du trenger for å drive med hobbyene dine",
  "addons.wundergroundRetrieveApiKey": "Hent API-nøkkelen din med denne lenken",
  "addons.wundergroundRetrieveStationId": "Hent din stasjons ID med denne lenken",
  "addons.wundergroundStationId": "Stasjons ID",
  "airQuality.airQuality": "Luftkvalitet",
  "airQuality.airQualityIndex": "Luftkvalitetsindeks",
  "airQuality.co": "Karbonmonoksid",
  "airQuality.good": "God",
  "airQuality.goodDescription": "Luftkvaliteten anses som tilfredsstillende og luftforurensning utgjør liten eller ingen risiko",
  "airQuality.hazardous": "Farlig",
  "airQuality.hazardousDescription": "Helsevarsel: Alle kan oppleve mer alvorlige helseeffekter",
  "airQuality.indoorAirQuality": "Innendørs luftkvalitet",
  "airQuality.moderate": "Moderat",
  "airQuality.moderateDescription": "Luftkvaliteten er akseptabel. For noen typer forurensninger kan det imidlertid være et moderat helseproblem for et svært lite antall mennesker som er uvanlig følsomme for luftforurensning.",
  "airQuality.no2": "Nitrogendioksid",
  "airQuality.o3": "Ozon",
  "airQuality.pm10": "Partikler med en diameter på 10 μm eller mindre",
  "airQuality.pm25": "Partikler med en diameter på 2,5 μm eller mindre",
  "airQuality.sensitiveUnhealthy": "Usunt for sensitive personer",
  "airQuality.sensitiveUnhealthyDescription": "Medlemmer av sensitive grupper kan oppleve helseeffekter. Det er ikke sannsynlig at allmennheten blir påvirket.",
  "airQuality.so2": "Svoveldioksid",
  "airQuality.unhealthy": "Usunn",
  "airQuality.unhealthyDescription": "Alle kan begynne å oppleve helseeffekter. Medlemmer av sensitive grupper kan oppleve mer alvorlige helseeffekter",
  "airQuality.veryUnhealthy": "Veldig usunt",
  "airQuality.veryUnhealthyDezscription": "Helsevarsler om nødstilfeller. Det er mer sannsynlig at hele befolkningen blir rammet.",
  "alerts.addAlert": "Legg til varsel",
  "alerts.addCondition": "Legg til betingelse",
  "alerts.alertAdded": "Varselet er lagt til",
  "alerts.alertAuthorizationNotice": "Varsler fungerer bare hvis du gir SmartMixin fullmakt til å vise varsler",
  "alerts.alertDeleted": "Varselet ble slettet",
  "alerts.alertEdited": "Varselet endret",
  "alerts.alertName": "Varselnavn",
  "alerts.alertWhen": "Jeg vil bli varslet når:",
  "alerts.aqiGreaterThan": "AQI høyere enn",
  "alerts.aqiGreaterThanThreshold": "AQI høyere enn grense på {value}{unit}",
  "alerts.aqiLessThan": "AQI lavere enn",
  "alerts.aqiLessThanThreshold": "AQI lavere enn grense på {value}{unit}",
  "alerts.atLeastOneCondition": "Du må legge til minst én betingelse",
  "alerts.co2GreaterThan": "CO2 høyere enn",
  "alerts.co2GreaterThanThreshold": "CO2 høyere enn grense på {value}{unit}",
  "alerts.co2LessThan": "CO2 lavere enn",
  "alerts.co2LessThanThreshold": "CO2 lavere enn grense på {value}{unit}",
  "alerts.conditions": "Betingelser",
  "alerts.createAlert": "Lag varsel",
  "alerts.dailyPrecipitationGreaterThan": "Daglig nedbør større enn",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Daglig nedbør over grensen på {value}{unit}",
  "alerts.deleteAlert": "Slett varsel",
  "alerts.editAlert": "Rediger varsel",
  "alerts.editCondition": "Rediger betingelser",
  "alerts.gustSpeedGreaterThan": "Vindkast høyere enn",
  "alerts.gustSpeedGreaterThanThreshold": "Vindkast høyere enn grense på {value}{unit}",
  "alerts.gustSpeedLessThan": "Vindkast lavere enn",
  "alerts.gustSpeedLessThanThreshold": "Vindkast lavere enn grense på {value}{unit}",
  "alerts.heatIndexGreaterThan": "Varmeindeks høyere enn",
  "alerts.heatIndexGreaterThanThreshold": "Varmeindeks høyere enn grense på {value}{unit}",
  "alerts.heatIndexLessThan": "Varmeindeks lavere enn",
  "alerts.heatIndexLessThanThreshold": "Varmeindeks lavere enn grense på {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex høyere enn",
  "alerts.humidexGreaterThanThreshold": "Humidex høyere enn grense på {value}{unit}",
  "alerts.humidexLessThan": "Humidex lavere enn",
  "alerts.humidexLessThanThreshold": "Humidex lavere enn grense på {value}{unit}",
  "alerts.humidityGreaterThan": "Luftfuktighet høyere enn",
  "alerts.humidityGreaterThanThreshold": "Luftfuktighet høyere enn grense på {value}{unit}",
  "alerts.humidityLessThan": "Luftfuktighet lavere enn",
  "alerts.humidityLessThanThreshold": "Luftfuktighet lavere enn grense på {value}{unit}",
  "alerts.inProgress": "Pågår",
  "alerts.myAlerts": "Mine varsler",
  "alerts.noConfiguredAlert": "Du har ikke konfigurert noen varsling ennå, begynn med å legge til en",
  "alerts.noiseGreaterThan": "Støy høyere enn",
  "alerts.noiseGreaterThanThreshold": "Støy høyere enn grense på {value}{unit}",
  "alerts.noiseLessThan": "Støy lavere enn",
  "alerts.noiseLessThanThreshold": "Støy lavere enn grense på {value}{unit}",
  "alerts.noteOnConditions": "Vær oppmerksom på at varselet utløses når alle betingelsene nedenfor er bekreftet",
  "alerts.pm10GreaterThan": "PM 10 høyere enn",
  "alerts.pm10GreaterThanThreshold": "PM 10 høyere ebb grense på {value}{unit}",
  "alerts.pm10LessThan": "PM 10 lavere enn",
  "alerts.pm10LessThanThreshold": "PM 10 lavere enn grense på {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 høyere enn",
  "alerts.pm1GreaterThanThreshold": "PM 1 høyere enn grense på {value}{unit}",
  "alerts.pm1LessThan": "PM 1 lavere enn",
  "alerts.pm1LessThanThreshold": "PM 1 lavere enn grense på {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 høyere enn",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 høyere enn grense på {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 lavere enn",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 lavere enn grense på {value}{unit}",
  "alerts.postStormSummary": "Oppsummering etter regn",
  "alerts.postStormSynopsisHelper": "Du får et oppsummeringsvarsel hver gang en regnbyge er over.",
  "alerts.postStormSynopsisSoleCondition": "Et sammendrag etter uvær kan ikke kombineres med andre betingelser.",
  "alerts.precipitationGreaterThan": "Nedbør per time større enn",
  "alerts.precipitationGreaterThanThreshold": "Nedbør per time over grensen på {value}{unit}",
  "alerts.pressureGreaterThan": "Lufttrykk høyere enn",
  "alerts.pressureGreaterThanThreshold": "Lufttrykk høyere enn grense på {value}{unit}",
  "alerts.pressureLessThan": "Lufttrykk lavere enn",
  "alerts.pressureLessThanThreshold": "Lufttrykk lavere enn grense på {value}{unit}",
  "alerts.rainRateGreaterThan": "Regnintensitet større enn",
  "alerts.rainRateGreaterThanThreshold": "Regnintensitet over grensen på {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Solstråling høyere enn",
  "alerts.solarRadiationGreaterThanThreshold": "Solstråling høyere enn grense på {value}{unit}",
  "alerts.solarRadiationLessThan": "Solstråling lavere enn",
  "alerts.solarRadiationLessThanThreshold": "Solstråling lavere enn grense på {value}{unit}",
  "alerts.temperatureGreaterThan": "Temperatur høyere enn",
  "alerts.temperatureGreaterThanThreshold": "Temperatur høyere enn grense på {value}{unit}",
  "alerts.temperatureLessThan": "Temperatur lavere enn",
  "alerts.temperatureLessThanThreshold": "Temperatur lavere enn grense på {value}{unit}",
  "alerts.thswGreaterThan": "THSW høyere enn",
  "alerts.thswGreaterThanThreshold": "THSW høyere enn grense på {value}{unit}",
  "alerts.thswLessThan": "THSW lavere enn",
  "alerts.thswLessThanThreshold": "THSW lavere enn grense på {value}{unit}",
  "alerts.thwGreaterThan": "THW høyere enn",
  "alerts.thwGreaterThanThreshold": "THW høyere enn grense på {value}{unit}",
  "alerts.thwLessThan": "THW lavere enn",
  "alerts.thwLessThanThreshold": "THW lavere enn grense på {value}{unit}",
  "alerts.uvGreaterThan": "UV-indeks høyere enn",
  "alerts.uvGreaterThanThreshold": "UV-indeks høyere enn grense på {value}{unit}",
  "alerts.uvLessThan": "UV-indeks lavere enn",
  "alerts.uvLessThanThreshold": "UV-indeks mindre enn grense på {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Sikt bedre enn grense på {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Sikt dårligere enn grense på {value}{unit}",
  "alerts.visiblityGreaterThan": "Sikt bedre enn",
  "alerts.visiblityLessThan": "Sikt dårligere enn",
  "alerts.whichMeasure": "Hvilke målinger vil du bli varslet for?",
  "alerts.whichModule": "Hvilken modul vil du bli varslet om?",
  "alerts.windChillGreaterThan": "Vindavkjøling høyere enn",
  "alerts.windChillGreaterThanThreshold": "Vindavkjøling høyere enn grense på {value}{unit}",
  "alerts.windChillLessThan": "Vindavkjøling lavere enn",
  "alerts.windChillLessThanThreshold": "Vindavkjøling lavere enn grense på {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vindhastigheten er høyere enn",
  "alerts.windSpeedGreaterThanThreshold": "Vindhastigheten er høyere enn grense på {value}{unit}",
  "alerts.windSpeedLessThan": "Vindhastigheten er lavere enn",
  "alerts.windSpeedLessThanThreshold": "Vindhastighet er lavere enn grense på {value}{unit}",
  "astral.astronomicalSunPhase": "Astronomisk {sunPhase}",
  "astral.civilSunPhase": "Civil {sunPhase}",
  "astral.dawn": "Grålysning",
  "astral.dusk": "Skumring",
  "astral.firstQuarter": "Første kvarter",
  "astral.fullMoon": "Fullmåne",
  "astral.lastQuarter": "Siste kvarter",
  "astral.moon": "Måne",
  "astral.moonPhases": "Månefaser",
  "astral.moonrise": "Måneoppgang",
  "astral.moonset": "Månenedgang",
  "astral.nauticalSunPhase": "Nautisk {sunPhase}",
  "astral.newMoon": "Nymåne",
  "astral.noon": "Middagstid",
  "astral.remainingDaylight": "Gjenværende dagslys",
  "astral.sunrise": "Soloppgang",
  "astral.sunriseAndSunset": "Soloppgang og solnedgang",
  "astral.sunriseAt": "Soloppgang kl. {time}",
  "astral.sunset": "Solnedgang",
  "astral.sunsetAt": "Solnedgang kl. {time}",
  "astral.totalDaylight": "Totalt dagslys",
  "astral.waningCrescent": "Avtagende halvmåne",
  "astral.waningGibbous": "Minkende måne (Ne)",
  "astral.waxingCrescent": "Voksende halvmåne",
  "astral.waxingGibbous": "Voksende måne (Ny)",
  "auth.alreadyHaveAccount": "Har du allerede en konto?",
  "auth.authContainerTagline": "Ditt personlige værdashbord. Koble til stasjonene dine og få sanntidsdata rett ved fingertuppene.",
  "auth.backToLogin": "Tilbake til innlogging",
  "auth.catchPhrase": "The Weather Intelligence Platform",
  "auth.checkYourEmail": "Sjekk e-posten din",
  "auth.continueWithApple": "Fortsett med Apple",
  "auth.continueWithFacebook": "Fortsett med Facebook",
  "auth.continueWithGoogle": "Fortsett med Google",
  "auth.email": "E-postadresse",
  "auth.emailRequiredLoginFacebook": "E-posttillatelse kreves.",
  "auth.emailVerification": "Epostbekreftelse",
  "auth.emailVerificationFailure": "Det oppstod et problem med E-postbekreftelsen din.",
  "auth.emailVerificationSuccess": "E-posten din har blitt bekreftet.",
  "auth.firstName": "Fornavn",
  "auth.forgotPassword": "Glemt passord?",
  "auth.forgotPasswordSubtitle": "Skriv inn e-postadressen din, så sender vi deg en lenke for å tilbakestille passordet.",
  "auth.lastName": "Etternavn",
  "auth.login": "Logg Inn",
  "auth.loginSubtitle": "Velkommen tilbake! Vennligst skriv inn opplysningene dine.",
  "auth.loginToSmartMixinDescription": "Skriv inn SmartMixin-legitimasjonen din for å få tilgang til kontoen din.",
  "auth.logout": "Logg ut",
  "auth.logoutConfirmation": "Er du sikker på at du vil logge ut?",
  "auth.noAccountYet": "Har du ikke en konto ennå?",
  "auth.or": "eller",
  "auth.password": "Passord",
  "auth.passwordAgain": "Gjenta passord",
  "auth.passwordReset": "Tilbakestill passord",
  "auth.passwordResetSuccess": "Passordet ditt er oppdatert.",
  "auth.register": "Opprett konto",
  "auth.registerDescription": "Opprett en gratis SmartMixin-konto for å koble til værstasjonene dine, følge værdata og få tilgang til avanserte analyseverktøy.",
  "auth.registerSubtitle": "Opprett kontoen din for å komme i gang.",
  "auth.registerSuccess": "Du er registrert! Vi har sendt en bekreftelseslenke til {emailAddress} med ytterligere instruksjoner.",
  "auth.restorePassword": "Gjenopprett passord",
  "auth.restorePasswordSuccess": "Vi har sendt en kobling for tilbakestilling av passord til {emailAddress} med ytterligere instruksjoner.",
  "auth.sendReset": "Send tilbakestillingsinstruksjoner",
  "auth.socialAccount": "eller bruk kontoen din",
  "auth.welcome": "Velkommen til SmartMixin",
  "auth.welcomeBack": "Velkommen tilbake!",
  "calendar.april": "April",
  "calendar.august": "August",
  "calendar.dateFormat": "Datoformat",
  "calendar.day": "Dag",
  "calendar.december": "Desember",
  "calendar.end": "Slutt",
  "calendar.february": "Februar",
  "calendar.hours": "Timer",
  "calendar.hoursShort": "timer",
  "calendar.january": "Januar",
  "calendar.july": "Juli",
  "calendar.june": "Juni",
  "calendar.last24Hours": "Siste 24 timer",
  "calendar.last30Days": "Siste 30 døgn",
  "calendar.last7Days": "Siste 7 døgn",
  "calendar.march": "Mars",
  "calendar.max": "Maks",
  "calendar.may": "Mai",
  "calendar.month": "Måned",
  "calendar.months": "måneder",
  "calendar.november": "November",
  "calendar.october": "Oktober",
  "calendar.oneDay": "1 dag",
  "calendar.oneHour": "1 time",
  "calendar.oneMonth": "1 måned",
  "calendar.oneWeek": "1 uke",
  "calendar.previous24Hours": "Siste 24 timer",
  "calendar.previous30Days": "Siste 30 døgn",
  "calendar.previous7Days": "Siste 7 døgn",
  "calendar.previousDay": "I går",
  "calendar.previousMonth": "Forrige måned",
  "calendar.previousWeek": "Forrige uke",
  "calendar.previousYear": "Forrige år",
  "calendar.sameDayLastYear": "Samme dag i fjor",
  "calendar.sameMonthLastYear": "Samme måned i fjor",
  "calendar.selectADate": "Velg en dato",
  "calendar.selectAMonth": "Velg en måned",
  "calendar.selectAYear": "Velg et år",
  "calendar.selectGranularity": "Velg detaljrikdom",
  "calendar.selectTimescale": "Velg en tidsskala",
  "calendar.september": "September",
  "calendar.sixHours": "6 timer",
  "calendar.start": "Begynnelse",
  "calendar.thirtyMinutes": "30 minutter",
  "calendar.threeHours": "3 timer",
  "calendar.use24HourFormat": "Bruk 24 timers format",
  "calendar.week": "Uke",
  "calendar.year": "År",
  "calendar.yesterday": "I går",
  "common.accountDeleted": "Kontoen din er slettet.",
  "common.accountOnHold": "Kontotilkoblingen din har utløpt. Koble til på nytt for å gjenoppta dataoppdateringer.",
  "common.add": "Legg til",
  "common.addAStation": "Legg til en stasjon",
  "common.addToFavorites": "Legg til i favoritter",
  "common.addYourOwnStation": "Legg til din egen stasjon",
  "common.alreadyPremium": "Du har allerede en premium konto!",
  "common.alsoAvailableOn": "Også tilgjengelig på:",
  "common.altitude": "Høyde",
  "common.analysis": "Analyse",
  "common.aroundMe": "Rundt meg",
  "common.articleCount": "{count, plural, one {count} artikkel} other {count} artikler}}",
  "common.articleNotFound": "Artikkel ikke funnet",
  "common.articleNotFoundDescription": "Artikkelen du leter etter finnes ikke.",
  "common.average": "Gjennomsnitt",
  "common.averageOverThePeriod": "Gjennomsnitt for perioden",
  "common.away": "Borte",
  "common.back": "Tilbake",
  "common.backToHelpCenter": "Tilbake til hjelpesenteret",
  "common.backToHome": "Tilbake til Forsiden",
  "common.bad": "Dårlig",
  "common.batteryLevel": "Batterinivå",
  "common.bestValue": "Beste Verdi",
  "common.billingDetailsAndroid": "Med prøveversjon vil du ikke bli belastet hvis du avbestiller 24 timer FØR den gratis introduksjonsperioden utløper. Når prøveperioden er over, kan du når som helst si opp SmartMixin abonnementet via Google Play -kontoinnstillingene, ellers vil den fornyes  automatisk. Avbestilling må gjøres 24 timer før slutten av abonnementsperioden for å unngå å bli belastet med et nytt gebyr vist i knappen ovenfor. Abonnementsbetalinger belastes din Google Play konto ved bekreftelse av kjøpet samt ved begynnelsen av hver fornyelsesperiode.",
  "common.billingDetailsIos": "Med prøveversjon vil du ikke bli belastet hvis du avbestiller 24 timer FØR den gratis introduksjonsperioden utløper. Når prøveperioden er over, kan du når som helst si opp SmartMixin abonnementet via App Store -kontoinnstillingene, ellers vil den fornyes  automatisk. Avbestilling må gjøres 24 timer før slutten av abonnementsperioden for å unngå å bli belastet med et nytt gebyr vist i knappen ovenfor. Abonnementsbetalinger belastes din App Store konto ved bekreftelse av kjøpet samt ved begynnelsen av hver fornyelsesperiode.",
  "common.boilerOn": "Kjele På",
  "common.browseByCategory": "Bla etter kategori",
  "common.calendarView": "Tabellvisning",
  "common.cancel": "Avbryt",
  "common.cannotBeEmpty": "Dette feltet kan ikke være tomt.",
  "common.cardDetails": "Kortdetaljer",
  "common.categoryNotFound": "Kategori ikke funnet",
  "common.categoryNotFoundDescription": "Denne kategorien finnes ikke eller har ingen artikler.",
  "common.charts": "Diagram",
  "common.chartView": "Diagramvisning",
  "common.clearRecentLocations": "Fjern alle",
  "common.close": "Lukk",
  "common.comparison": "Sammenligning",
  "common.currentDay": "Gjeldende dag",
  "common.currentLocation": "Nåværende plassering",
  "common.currentObservations": "Siste måling",
  "common.currentRainEvent": "Nåværende regnhendelse",
  "common.currentRate": "Nåværende mengde",
  "common.currentWeatherConditions": "Nåværende forhold",
  "common.customizeComparisonMetrics": "Tilpass målinger",
  "common.customizeComparisonMetricsDescription": "Dra elementer for å omorganisere sammenligningsmetrikker. Trykk på øyeikonet for å vise eller skjule målinger.",
  "common.customizeDashboard": "Tilpass",
  "common.customizeDashboardDescription": "Dra elementer for å endre rekkefølgen på dashbordet. Trykk på øyeikonet for å vise eller skjule seksjoner.",
  "common.customizedStationName": "Tilpasset stasjonsnavn",
  "common.dailyForecast": "Langtidsvarsel",
  "common.dashboard": "Dashboard",
  "common.default": "Standard",
  "common.defaultForecastModelChip": "Standard · {name}",
  "common.delete": "Slett",
  "common.deleteAccount": "Slett kontoen din",
  "common.deleteAccountConfirmation": "Er du sikker på at du vil slette kontoen din? Du kan ikke angre hvis du sletter konto!",
  "common.deleteAccountDescription": "Denne handlingen sletter kontoen din og all informasjonen din. Det er ingen vei tilbake.",
  "common.details": "Detaljer",
  "common.edit": "Rediger",
  "common.editor": "Editor",
  "common.endTime": "Sluttid",
  "common.exitFullscreen": "Avslutt fullskjerm",
  "common.exploreWeatherMap": "Utforsk Værkartet",
  "common.favoriteLocations": "Favoritter",
  "common.favoriteLocationsEmpty": "Du kan legge til opptil 5 favorittsteder.",
  "common.favoriteStations": "Favorittstasjoner",
  "common.feedbackHelpsImprove": "Din tilbakemelding hjelper oss med å forbedre hjelpeartiklene våre.",
  "common.filterStationDescription": "Ikke vis stasjoner med upålitelige målinger",
  "common.filterStations": "Filtrer stasjoner",
  "common.filterStationSourceDescription": "Velg stasjonsleverandører som du vil vise på kartet",
  "common.findStationsNearYou": "Finn stasjoner i nærheten",
  "common.firmwareVersion": "Firmware versjon",
  "common.forecast": "Værmelding",
  "common.forecastComparisonDescription": "Sammenlign enkelt prognosemodelldata fra flere kilder",
  "common.forecastModelComparison": "Sammenligning av prognosemodeller",
  "common.forecastModelCoverage": "Dekning",
  "common.forecastModelDescription": "Beskrivelse",
  "common.forecastModelDescription_AROME": "Météo Frances konveksjonsoppløsende høyoppløselige modell over Vest-Europa med 1,3 km oppløsning. Best i klassen for kortsiktige prognoser i Frankrike; oppdatert hver tredje time.",
  "common.forecastModelDescription_ARPEGE_EU": "Météo Frances europeiske rede av ARPEGE-modellen med 10 km oppløsning. Mellomlangs varsel over Europa, oppdatert fire ganger daglig.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Météo Frances globale numeriske værmodell med 25 km oppløsning, som kjører opp til ca. 4 dager. Oppdatert fire ganger daglig.",
  "common.forecastModelDescription_EC_GDPS": "Environment Canadas Global Deterministic Prediction System: en verdensomspennende mellomlangs modell med 15 km oppløsning som kjører opp til 10 dager, oppdatert to ganger daglig.",
  "common.forecastModelDescription_EC_RDPS": "Environment Canadas Regional Deterministic Prediction System: en mellomlangs modell over Nord-Amerika med 10 km oppløsning, oppdatert fire ganger daglig.",
  "common.forecastModelDescription_GFS": "NOAAs flaggskip mellomlangs globale modell. Dekker hele planeten med 25 km oppløsning opp til 16 dager, oppdatert fire ganger daglig.",
  "common.forecastModelDescription_HRRR_CONUS": "NOAAs High-Resolution Rapid Refresh: en konveksjonsoppløsende modell over det kontinentale USA med 3 km oppløsning, oppdatert hver time. Best egnet for veldig kortsiktige prognoser for tordenvær og hardt vær.",
  "common.forecastModelDescription_ICON_DE": "DWDs høyoppløselige konveksjonsoppløsende modell over Tyskland og omkringliggende land med 2,2 km oppløsning. Kortsiktige prognoser oppdatert to ganger daglig.",
  "common.forecastModelDescription_ICON_EU": "DWDs europeiske rede av ICON-modellen med 7 km oppløsning som dekker Europa og Nord-Atlanteren. Mellomlangs varsel oppdatert fire ganger daglig.",
  "common.forecastModelDescription_MET_NORWAY": "Det Norske Meteorologiske Institutts åpne værvarslingstjeneste, som blander høyoppløselige nordiske modeller med ECMWF-data for å gi verdensomspennende varsler opp til 10 dager frem.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "AROME-rede over de franske Antillene (Guadeloupe, Martinique) med 2,5 km oppløsning. Kortsiktige prognoser oppdatert fire ganger daglig.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "AROME-rede over Fransk Guyana med 2,5 km oppløsning. Kortsiktige prognoser oppdatert fire ganger daglig.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "AROME-rede over Ny-Caledonia med 2,5 km oppløsning. Kortsiktige prognoser oppdatert fire ganger daglig.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "AROME-rede over Fransk Polynesia med 2,5 km oppløsning. Kortsiktige prognoser oppdatert fire ganger daglig.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "AROME-rede over Réunion og Mayotte med 2,5 km oppløsning. Kortsiktige prognoser oppdatert fire ganger daglig.",
  "common.forecastModelDescription_NAM_CONUS": "NOAAs North American Mesoscale modell-rede over det kontinentale USA med 5 km oppløsning. Kortsiktige prognoser oppdatert fire ganger daglig.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "NOAAs North American Mesoscale modell som dekker hele Nord-Amerika med 32 km oppløsning. Oppdatert fire ganger daglig.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "SmartMixins flaggskipvarsel. For hver time på din plassering velger vi den beste tilgjengelige modellen — vanligvis en høyoppløselig regional modell der det finnes en (AROME i Frankrike, ICON-D2 i Tyskland, HRRR i USA, ARPEGE Europe over kontinentet…) og faller tilbake på en global modell andre steder — og fyller deretter eventuelle hull fra nabokilder. Resultatet er ett enkelt sømløst varsel som dekker hvor som helst i verden opp til 14 dager, automatisk oppdatert hver gang en av de underliggende modellene oppdateres.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Weatherflows proprietære globale varsel som blander flere numeriske værmodeller med observasjoner fra dets Tempest-værstasjonsnettverk. 10-dagers verdensomspennende horisont.",
  "common.forecastModelDetailTitle": "Værvarselmodell",
  "common.forecastModelScopeGlobal": "Global",
  "common.forecastModelScopeGlobalDescription": "Denne modellen dekker hele kloden.",
  "common.forecastModelScopeRegional": "Regional",
  "common.forecastModelScopeRegionalDescription": "Denne modellen dekker kun en bestemt region.",
  "common.forecastModelSpecifications": "Spesifikasjoner",
  "common.forecastSources": "Prognosekilder",
  "common.freeAccount": "Gratis konto",
  "common.freeSubscription": "Gratis Premium abonnement",
  "common.freeTrialForPeriod": "Gratis prøveperiode i {period} dager",
  "common.frequency": "Frekvens",
  "common.full": "Full",
  "common.fullscreen": "Fullskjerm",
  "common.getStartedFree": "Kom i Gang Gratis",
  "common.getUnlimitedAccess": "Ubegrenset tilgang til:",
  "common.good": "God",
  "common.help": "Hjelp",
  "common.helpCategoryAccount": "Konto",
  "common.helpCategoryBilling": "Fakturering",
  "common.helpCategoryGettingStarted": "Kom i gang",
  "common.helpCategoryProviders": "Leverandører",
  "common.helpCategoryStations": "Stasjoner",
  "common.helpCategoryTroubleshooting": "Feilsøking",
  "common.helpCenter": "Hjelpesenter",
  "common.helpCenterDescription": "Finn svar på vanlige spørsmål og lær hvordan du får mest mulig ut av SmartMixin.",
  "common.hg": "Frostvakt",
  "common.hidden": "Skjulte",
  "common.hiddenSensors": "Skjulte sensorer",
  "common.hiddenStations": "Skjulte stasjoner",
  "common.hiddenStationsDescription": "Du kan fjerne en stasjon ved å tappe øyeikonet ved siden av.",
  "common.high": "Høyde",
  "common.home": "Hjem",
  "common.homeConnectService": "Eier du en værstasjon? Koble til tjenesten din",
  "common.homeInformation": "Hjem informasjon",
  "common.homeIntroduction": "Begynn å koble dine eksterne kontoer for å benytte SmartMixin funksjonene.",
  "common.homeName": "Hjemmets navn",
  "common.homeSubtitle": "Ditt vær, alt på ett sted",
  "common.horizon": "Gyldighet",
  "common.horizonValue": "opptil {value} timer",
  "common.iDontKnowYet": "Jeg vet ikke ennå",
  "common.indoor": "Innendørs",
  "common.lastRainEvent": "Siste regnhendelse",
  "common.lastUpdate": "Siste oppdatering",
  "common.legendLightningHelp": "Fargen viser alderen på hvert lynnedslag de siste {minutes} minuttene — nyeste i hvitt, eldste i mørkerødt.",
  "common.legendNewest": "Nyeste",
  "common.legendOldest": "Eldste",
  "common.legendStationsHelp": "Markørfargen gjenspeiler verdien av den valgte målingen.",
  "common.lightningDataAttribution": "Lyndata: Blitzortung.org",
  "common.lightningStrikes": "Lynnedslag",
  "common.lightningStrikesDescription": "Vis lynnedslag i sanntid på kartet",
  "common.loading": "Laster inn",
  "common.location": "Plassering",
  "common.locationAddedToFavorites": "Plassering lagt til favoritter",
  "common.locationNotGranted": "Plasseringstillatelse er ikke gitt. Gi tilgang til ditt sted i enhetsinnstillinger.",
  "common.locationRemovedFromFavorites": "Plassering fjernet fra favoritter",
  "common.locations": "Steder",
  "common.low": "Lav",
  "common.manage": "Administrer",
  "common.manageAccount": "Administrer konto",
  "common.manageMySubscription": "Administrer abonnementet mitt",
  "common.manageSensors": "Administrer sensorer",
  "common.manageSensorsDescription": "Dra elementer for å endre rekkefølgen på sensorer. Trykk på øyeikonet for å vise eller skjule sensorer. Trykk på et navn for å gi det nytt navn.",
  "common.manualBoost": "Manuell boost",
  "common.manualSetpointUntil": "Manuelt settpunkt inntil",
  "common.mapLayers": "Kartlag",
  "common.mapLegend": "Karttegnforklaring",
  "common.maxFavoriteLocationsReached": "Du kan bare ha opptil 5 favorittsteder. Fjern en for å legge til en annen.",
  "common.measureToDisplay": "Målinger å vise",
  "common.medium": "Middels",
  "common.meshSize": "Rutestørrelse",
  "common.minRead": "{minutes} min lesing",
  "common.modifyFavoriteStations": "Endre favorittstasjoner",
  "common.modifyFavoriteStationsDescription": "Du kan omorganisere favorittstasjonene dine ved å dra dem. Du kan også fjerne dem fra listen.",
  "common.moduleType": "Modultype",
  "common.monthTotal": "Måned totalt",
  "common.more": "Mer",
  "common.moreInformation": "Mer informasjon",
  "common.myLocation": "Min posisjon",
  "common.nearbyWeatherStations": "I nærheten værstasjoner",
  "common.next": "NESTE",
  "common.nextHours": "Neste timer",
  "common.no": "Nei",
  "common.noAccountNeeded": "Ingen konto nødvendig",
  "common.noDataForThisPeriod": "Ingen data for denne perioden",
  "common.noLocationsFound": "Ingen steder funnet",
  "common.noNetatmoWeatherStationYet": "Du har ikke en Netatmo værstasjon.",
  "common.noOutdoorModule": "Det er ingen fungerende utemodul for denne stasjonen.",
  "common.noStationsFound": "Ingen stasjoner funnet",
  "common.noThermostatYet": "Du har ikke termostat ennå.",
  "common.notNow": "Ikke nå",
  "common.notPurchasedYet": "Det ser ut til at dette ikke er kjøpt ennå.",
  "common.noWeatherStation": "Ingen værstasjon",
  "common.noWeatherStationYet": "Du har ikke en værstasjon ennå.",
  "common.numberOfActiveWarnings": "{warning_count} aktive værvarsler",
  "common.openSettings": "Åpne innstillinger",
  "common.orChooseMonthly": "Eller velg månedlig:",
  "common.outdatedModule": "Dataene for denne modulen er utdaterte.",
  "common.outdoor": "Utendørs",
  "common.outdoorTemperature": "Utetemperatur",
  "common.pageNotFound": "Side Ikke Funnet",
  "common.pageNotFoundDescription": "Siden du leter etter finnes ikke eller har blitt flyttet.",
  "common.passwordUpdated": "Passordet er oppdatert.",
  "common.personalWeatherIntelligence": "Din Personlige Værintelligens",
  "common.premiumAccount": "Premium bruker",
  "common.premiumDescription": "Premium abonnement låser opp et stort utvalg av tilleggsfunksjoner som: Avansert væranalyse, datasammenligning, regionale prognosemodeller og mye mer.",
  "common.premiumFeatureAlerts": "Værvarsler",
  "common.premiumFeatureAnalysis": "Avansert Væranalyse",
  "common.premiumFeatureCharts": "Diagramsammenligninger",
  "common.premiumFeatureExport": "Dataeksport",
  "common.premiumFeatureForecast": "Regionale Prognosemodeller",
  "common.premiumFeatureNotification": "Statuslinje-Widget",
  "common.premiumFeatureTitle": "Premium Funksjon",
  "common.premiumFeatureWidgets": "Startskjerm-widgeter",
  "common.pressureSummary": "Trykkoppsummering",
  "common.previous": "Tidligere",
  "common.previousHours": "Tidligere timer",
  "common.profileUpdated": "Profilen er oppdatert.",
  "common.purchasedNetatmoPro": "Du har tidligere kjøpt Netatmo Pro ({date}). Den gir deg tilgang til Premium funksjonene. Abonner på ett av følgende tilbud hvis du vil ha tilgang til alle Premium funksjoner.",
  "common.radarDataAttribution": "Radardata: RainViewer.com",
  "common.rain": "Regn",
  "common.rainEvents": "Regnhendelser",
  "common.rainfallMeasurement": "Nedbørsmåling",
  "common.rainRadar": "Regnradar",
  "common.rainRadarDescription": "Vis regnradaroverlegg på kartet",
  "common.rainSummary": "Regn oppsummering",
  "common.range": "Område",
  "common.recentLocations": "Nylig",
  "common.recentLocationsEmpty": "Din nyere historie er tom.",
  "common.recentStations": "Nylige stasjoner",
  "common.relatedArticles": "Relaterte artikler",
  "common.relay": "Videresende",
  "common.removeFromFavorites": "Fjern fra favoritter",
  "common.renameSensors": "Gi nytt navn til sensorer",
  "common.resetZoom": "Tilbakestill Zoom",
  "common.restorePurchase": "Gjenopprett kjøp",
  "common.room": "Rom",
  "common.rooms": "Rom",
  "common.savingsPercent": "Spar {percent}%",
  "common.searchArticles": "Søk artikler...",
  "common.searchForALocation": "Søk etter et sted...",
  "common.searchForLocation": "Søk etter et sted",
  "common.searchForWeatherStation": "Søk etter en værstasjon",
  "common.searchResults": "Søkeresultater",
  "common.searchResultsEmpty": "Ingen resultater funnet.",
  "common.searchStationsDescription": "Skriv inn en by, adresse eller stedsnavn for å finne værstasjoner i nærheten.",
  "common.searchStationsHint": "Bruk søkefeltet ovenfor for å oppdage værstasjoner hvor som helst i verden.",
  "common.selectStationForComparison": "Velg en stasjon å sammenligne med",
  "common.selectWeatherForecastProvider": "Velg en værleverandør",
  "common.serialNumber": "Serienummer",
  "common.share": "Del",
  "common.shareOutdoorMeasures": "Del dine utendørsmålinger",
  "common.shareOutdoorMeasuresDescription": "Delta i SmartMixin samfunnet ved å gjøre dine utendørsmålinger synlige for andre. Innendørsmålinger vil ikke bli delt.",
  "common.shareYourWeather": "Del været ditt",
  "common.signalStrength": "Signalstyrke",
  "common.skip": "Hopp over",
  "common.smartThermostat": "Smart termostat",
  "common.smartValve": "Smart ventil",
  "common.snow": "Snø",
  "common.start": "Start",
  "common.startFreeTrial": "Start Gratis Prøveperiode",
  "common.startTime": "Starttid",
  "common.station": "stasjon",
  "common.stationAddedToFavorites": "Stasjon lagt til favoritter",
  "common.stationComparison": "Stasjonssammenligning",
  "common.stationComparisonDescription": "Sammenlign historiske værdata med en annen stasjon",
  "common.stationInformation": "Stasjonsinformasjon",
  "common.stationName": "Stasjonens navn",
  "common.stationObservationsDescription": "Vis de siste observasjonene fra værstasjoner",
  "common.stationRemovedFromFavorites": "Stasjonen fjernet fra favoritter",
  "common.stations": "stasjoner",
  "common.stationsNear": "Stasjoner nær",
  "common.stationType": "Stasjonstype",
  "common.statusOffline": "Frakoblet",
  "common.statusOnline": "Tilkoblet",
  "common.statusStale": "Utdatert",
  "common.statusSyncing": "Synkroniserer",
  "common.subscribeNow": "Abonner nå - uten prøveperiode",
  "common.sumOverThePeriod": "Sum for perioden",
  "common.switchToPremium": "Bytt til SmartMixin Premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Temperaturoppsummering",
  "common.thankYouForFeedback": "Takk for tilbakemeldingen!",
  "common.thenPrice": "deretter {price}",
  "common.timeSelection": "Tidsvalg",
  "common.timezone": "Tidssone",
  "common.totalDuration": "Total varighet",
  "common.tryAnotherLocation": "Vi fant ingen værstasjoner i nærheten av dette stedet. Prøv å søke i et annet område.",
  "common.unknown": "Ukjent",
  "common.untilChanged": "Inntil endret",
  "common.untilTime": "Frem til {time}",
  "common.upgrade": "Oppgradering",
  "common.upgradeRequiredAndroid": "En oppgradering av app er nødvendig. Gå til Google Play for å oppgradere.",
  "common.upgradeRequiredIos": "En oppgradering av app er nødvendig. Gå til app store for å oppgradere.",
  "common.validate": "Validere",
  "common.validEmail": "En gyldig E-postadresse kreves.",
  "common.very_low": "Veldig lav",
  "common.visitNetatmoWebsite": "Besøk Netatmo nettsted",
  "common.wasArticleHelpful": "Var denne artikkelen nyttig?",
  "common.weatherCondition": "Værforhold",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain er en ekstra datakilde levert via Tempest Weather System, drevet av Nearcast Technology. NC Regndata er et estimat av gjennomsnittlig nedbørakkumulering rundt Tempest på nabolagsnivå",
  "common.weatherForecastModels": "Værmeldingsmodeller",
  "common.weatherIntelligencePlatform": "Værintelligensplattformen",
  "common.weatherMap": "Værkart",
  "common.weatherMapMetaDescription": "SmartMixin tilbyr interaktive vær- og radarkart for værforhold over hele verden.",
  "common.weatherObservations": "Værobservasjoner",
  "common.weatherStation": "Værstasjon",
  "common.weatherStations": "Værstasjoner",
  "common.welcome": "Velkommen til SmartMixin!",
  "common.whenBackHome": "Når kommer du hjem?",
  "common.wifiStrength": "WiFi styrke",
  "common.wind": "Vind",
  "common.windMeasurement": "Vindmåling",
  "common.windSpeed": "Vindhastighet",
  "common.windSummary": "Vindoppsummering",
  "common.yearToDate": "År til dags dato",
  "common.yes": "Ja",
  "intro.locationDescription": "Aktiver stedstilgang for å få nøyaktige værvarsler tilpasset ditt eksakte område — ikke flere generelle prognoser.",
  "intro.locationTitle": "Prognoser laget for deg",
  "intro.notificationDescription": "Slå på varsler for å få tidsriktige meldinger om værendringer som betyr noe for deg — regn, snø eller alvorlige forhold, akkurat når du trenger det.",
  "intro.notificationsTitle": "Gå aldri glipp av en værendring",
  "intro.readyDescription": "Nyt presise prognoser, sanntids værinnsikt og stasjonsdata fra hele verden — alt i én kraftig app.",
  "intro.readyTitle": "Du er klar!",
  "intro.welcomeDescription": "Få hyperlokale prognoser fra ledende værbyråer — pluss tilgang til over 40 000 værstasjoner over hele verden for å se reelle forhold, både nåtid og fortid.",
  "intro.welcomeTitle": "Været ditt, gjenoppfunnet",
  "landing.alerts": "Varsler",
  "landing.alertsDescription": "Lag dine egne varsler og bli varslet så snart de utløses.",
  "landing.featureAlertsDescription": "Sett opp tilpassede varsler for forhold som interesserer deg—temperatur, vind, nedbør og mer.",
  "landing.featureAlertsTitle": "Smarte varsler",
  "landing.featureAnalyticsDescription": "Dykk ned i dataene dine med interaktive diagrammer, side-ved-side sammenligninger og trendanalyser som går utover grunnleggende målinger.",
  "landing.featureAnalyticsTitle": "Kraftig analyse",
  "landing.featureExportDescription": "Last ned dataene dine i CSV-format for analyse i Excel, integrasjon med andre systemer eller sikkerhetskopiering.",
  "landing.featureExportTitle": "Eksporter overalt",
  "landing.featureForecastDescription": "Sammenlign prognoser fra over 10 værmodeller inkludert GFS, ECMWF, ICON og flere for å se hvilken som fungerer best for din plassering.",
  "landing.featureForecastTitle": "Prognosesammenligning",
  "landing.featureHistoryDescription": "Få tilgang til historiske data med time-, dags- og månedsskala. Eksporter til CSV for forskning eller personlige arkiver.",
  "landing.featureHistoryTitle": "Rik historikk",
  "landing.featureMultiBrandDescription": "Koble til stasjoner fra Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow og flere—alt i ett dashbord.",
  "landing.featureMultiBrandTitle": "Støtte for flere merker",
  "landing.featuresSubtitle": "Designet for værentusiaster som krever mer enn en grunnleggende værstasjonsapp.",
  "landing.featuresTitle": "Alt du trenger for å analysere været",
  "landing.finalCtaButton": "Opprett gratis konto",
  "landing.finalCtaSubtitle": "Bli med tusenvis av værentusiaster som stoler på SmartMixin for værdataene sine.",
  "landing.finalCtaTitle": "Klar til å forbedre væropplevelsen din?",
  "landing.forecastDescription": "Få tilgang til noen av de beste værmeldingsmodellene og sammenlign dem for å få din egen ide om hvordan været vil bli.",
  "landing.forecasts": "Prognoser",
  "landing.heroCta": "Start gratis",
  "landing.heroDescription": "Kombiner flere værstasjoner fra hvilket som helst merke, sammenlign prognosemodeller og analyser dataene dine med detaljerte diagrammer og eksporter.",
  "landing.heroSecondaryCta": "Se funksjoner",
  "landing.heroTagline": "For værentusiaster",
  "landing.heroTitle": "Alle værdata. Én plattform.",
  "landing.pricingFeatureAdvancedMetrics": "Avanserte målinger",
  "landing.pricingFeatureAlerts": "Tilpassede varsler",
  "landing.pricingFeatureExport": "Dataeksport (CSV)",
  "landing.pricingFeatureForecastComparison": "Prognosesammenligning",
  "landing.pricingFeatureForecasts": "Prognosemodeller",
  "landing.pricingFeatureForecastsFreeTier": "1 modell",
  "landing.pricingFeatureForecastsPremiumTier": "Alle modeller (10+)",
  "landing.pricingFeatureReports": "Analyser og rapporter",
  "landing.pricingFeatureStationComparison": "Stasjonssammenligning",
  "landing.pricingFeatureWidgets": "Startskjerm-widgeter",
  "landing.pricingFeatureYearOverYear": "År-til-år-analyse",
  "landing.pricingFree": "Gratis",
  "landing.pricingFreeCta": "Kom i gang",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Mest populær",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Kom i gang",
  "landing.pricingPremiumDescription": "Fra 1,99 €/måned — abonner på nett, App Store eller Google Play",
  "landing.pricingSubtitle": "Start gratis, oppgrader når du trenger mer.",
  "landing.pricingTitle": "Enkel, gjennomsiktig prising",
  "landing.smartMixinDescription": "SmartMixin er en applikasjon som gir tilgang til værstasjonen din og 40K+ andre stasjoner over hele verden. Det hjelper deg å se og forstå værdata.",
  "landing.statBrands": "Støttede merker",
  "landing.statForecasts": "Prognosemodeller",
  "landing.statStations": "Tilkoblede stasjoner",
  "landing.supportedDevices": "Støttede enheter",
  "landing.supportedDevicesDescription": "På toppen av stasjonene fra World Meteorological Organization, støtter SmartMixin et økende antall værstasjonsmerker.",
  "landing.supportedDevicesNote": "Pluss over 40 000 offentlige stasjoner fra Verdens meteorologiorganisasjon",
  "landing.supportedDevicesSubtitle": "Koble til værstasjoner fra ledende merker og se alle data på ett sted.",
  "landing.supportedDevicesTitle": "Fungerer med stasjonene dine",
  "landing.thermostatDescription": "Koble til Netatmo-termostaten din for å sammenligne oppvarmingsmønstre med utendørsforhold.",
  "landing.thermostatManufacturers": "Termostatprodusenter støttes også for å korrelere oppvarming med utendørsforhold.",
  "landing.thermostatTitle": "Smarthus-integrasjon",
  "landing.weatherAnalysis": "Væranalyse",
  "landing.weatherAnalysisDescription": "SmartMix kommer med massevis av datavisualisering som lar deg analysere værdata.",
  "landing.weatherAssistant": "Værassistenten din",
  "landing.weatherAssistantDescription": "Enten du er interessert i nåværende, historiske eller varslede værforhold, gir SmartMixin en rekke innsikter når du trenger dem.",
  "landing.weatherForecastModels": "Værmeldingsmodeller",
  "landing.weatherForecastModelsDescription": "SmartMixin gir tilgang til de mest nøyaktige værmeldingsmodellene. Du kan enkelt sammenligne deres prognoser og lage din egen idé.",
  "landing.weatherMap": "Værkart",
  "landing.weatherMapDescription": "Bla gjennom kartet og visualiser hvordan været er overalt på kloden.",
  "network.cancelError": "Forespørselen er kansellert",
  "network.connectionError": "Serveren er ikke tilgjengelig",
  "network.networkError": "Nettverk ikke tilgjengelig",
  "network.serverError": "Noe gikk galt...",
  "network.timeoutError": "Tidsavbrudd for tilkobling",
  "network.unknownError": "Ukjent feil",
  "providerHints.ambientWeatherApiKey": "Opprettet i kontoinnstillingene på ambientweather.net.",
  "providerHints.davisApiSecret": "Vises bare én gang når du opprettet V2 API-nøkkelen — oppbevar trygt.",
  "providerHints.davisV2ApiKey": "Fra V2 API-nøkkelsiden på weatherlink.com.",
  "providerHints.ecowittApi": "Fra API-siden på Ecowitt-kontoen din.",
  "providerHints.ecowittApp": "Applikasjonsnøkkelen, også fra Ecowitt-kontoen din.",
  "providerHints.myAcuriteCredentialsBanner": "Bruk e-post og passord til My AcuRite-kontoen din — ikke SmartMixin-innloggingen.",
  "providerHints.myAcuriteEmail": "E-postadressen til My AcuRite-kontoen din — ikke SmartMixin-innloggingen.",
  "providerHints.myAcuritePassword": "Passordet til My AcuRite-kontoen din.",
  "providerHints.weatherflowToken": "Personlig token fra tempestwx.com → innstillinger → dataautorisasjoner.",
  "providerHints.wundergroundEditKey": "Bruk en annen nøkkel",
  "providerHints.wundergroundKey": "En lang streng fra API-nøkkelsiden på Weather Underground-kontoen din — ikke wunderground.com-passordet ditt.",
  "providerHints.wundergroundKeyExample": "f.eks. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-nøkkel bekreftet",
  "providerHints.wundergroundKeyVerifying": "Sjekker nøkkel…",
  "providerHints.wundergroundNoStationsNearby": "Ingen stasjoner funnet i nærheten. Prøv å skrive inn en stasjons-ID direkte.",
  "providerHints.wundergroundStationId": "Hvilken som helst Weather Underground-stasjons-ID — din egen eller en offentlig stasjon i nærheten.",
  "providerHints.wundergroundStationIdExample": "f.eks. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Hent Ambient Weather API-nøkkelen din.",
  "providerIntro.davisStep2": "Hent Davis V2 API-nøkkelen og API-hemmeligheten din.",
  "providerIntro.ecowittStep2": "Hent Ecowitt API-nøkkelen og applikasjonsnøkkelen din.",
  "providerIntro.getStarted": "Kom i gang",
  "providerIntro.myAcuriteStep2": "Bruk e-post og passord til din eksisterende My AcuRite-konto.",
  "providerIntro.netatmoEnergyStep2": "Logg inn på Netatmo når du blir bedt om det — ingen API-nøkkel nødvendig.",
  "providerIntro.netatmoWeatherStep2": "Logg inn på Netatmo når du blir bedt om det — ingen API-nøkkel nødvendig.",
  "providerIntro.signupBanner": "Nesten ferdig — opprett en gratis SmartMixin-konto for å koble til {provider}.",
  "providerIntro.step1": "Logg inn på SmartMixin-kontoen din (IKKE {provider}-innloggingen).",
  "providerIntro.step3EmailPassword": "Skriv inn her.",
  "providerIntro.step3KeyOrToken": "Lim inn her.",
  "providerIntro.step3OAuth": "Godkjenn SmartMixin i popup-vinduet.",
  "providerIntro.step3Wunderground": "Lim inn API-nøkkelen din, og velg deretter en stasjon i nærheten eller skriv inn en hvilken som helst stasjons-ID.",
  "providerIntro.title": "Koble til {provider}",
  "providerIntro.weatherflowStep2": "Hent den personlige Tempest-tokenet ditt.",
  "providerIntro.wundergroundBrowsePublic": "Har du ingen stasjon? Bla gjennom offentlige",
  "providerIntro.wundergroundFindNearby": "Finn stasjoner i nærheten",
  "providerIntro.wundergroundOrEnterId": "Eller skriv inn en stasjons-ID",
  "providerIntro.wundergroundStep2": "Hent Weather Underground API-nøkkelen din. Deretter kan du koble til en hvilken som helst stasjon — din egen eller en offentlig.",
  "reports.agroMeteorology": "Agrometeorologi",
  "reports.analysis": "Analyse",
  "reports.annualCumulativeRainfallComparison": "Årlig nedbørssammenligning",
  "reports.annualHeatingDurationComparison": "Sammenligning av årlig oppvarmingsvarighet",
  "reports.annualHeatingEfficiency": "Årlig oppvarmingseffektivitet",
  "reports.annualIndoorComparison": "Årlig innendørs sammenligning",
  "reports.annualIndoorReport": "Årlig innendørsrapport",
  "reports.annualOutdoorComparison": "Årlig utendørs sammenligning",
  "reports.annualOutdoorReport": "Årlig utendørsrapport",
  "reports.annualReport": "Årlig rapport",
  "reports.annualSolarReport": "Årlig solrapport",
  "reports.annualWaterBalance": "Årlig vannbalanse",
  "reports.annualWaterBalanceCarryOver": "Overfør forrige år",
  "reports.annualWaterBalanceDescription": "Vannbalansen (forenklet versjon, kun regn og evapotranspirasjon brukes) hjelper til med å styre vannforsyningen",
  "reports.avgHumidity": "Gjennomsnittlig luftfuktighet",
  "reports.avgMaxTemperature": "Gjennomsnittlig T ° maks",
  "reports.avgMinTemperature": "Gjennomsnittlig T ° min",
  "reports.avgPressure": "Gjennomsnittlig lufttrykk",
  "reports.avgTemperature": "Gjennomsnittstemperatur",
  "reports.comfortable": "Komfortabelt (45% {lessThan} Fuktighet ≤ 60%)",
  "reports.cumulativeRainfall": "Kumulativ nedbør",
  "reports.cumulativeRainfallDescription": "Følg den totale nedbøren som akkumuleres over den valgte perioden.",
  "reports.dailyMaxRainfall": "Daglig maks. nedbør",
  "reports.dataExport": "Eksporter data",
  "reports.dataExportXlsxFormatDescription": "Eksporter alle stasjonens værdata i Excel format (*.xlsx). Når du klikker på knappen vil du om noen minutter motta en E-post med de behandlede dataene.",
  "reports.daysWithFrost": "Dager med kulde",
  "reports.daysWithoutThaw": "Dager uten smelting",
  "reports.daysWithStrongFrost": "Dager med sterk kulde",
  "reports.emailSent": "En E-post er sendt til postkassen din",
  "reports.grasslandTemperatureSum": "Sum temperatur på gress",
  "reports.grasslandTemperatureSumDescription": "Når summen {threshold} overskrides om våren er den bærekraftige starten på vegetasjon/landbruk oppnådd (fungerer for Europa)",
  "reports.growingDegreeDays": "Vekstgraddager",
  "reports.highPressure": "Antisyklon (gjennomsnittlig trykk ≥ 1013mbar)",
  "reports.indoorReport": "Innendørsrapport",
  "reports.keyFacts": "Nøkkelord",
  "reports.longestRunOfRainyDays": "Lengste periode med regnværsdager",
  "reports.longestRunWithoutRun": "Lengste periode uten regn",
  "reports.lowPressure": "Lavt lufttrykk (gjennomsnittlig trykk {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maksimal luftfuktighet",
  "reports.maxPressure": "Maksimalt lufttrykk",
  "reports.maxPressureMagnitude24h": "Maksimal forskjell (/24t)",
  "reports.maxTemperature": "Maksimal temperatur",
  "reports.maxTempGreaterThan": "T°maks ≥",
  "reports.maxTempMagnitude24h": "Maksimal forskjell (/24t)",
  "reports.minHumidity": "Minimum luftfuktighet",
  "reports.minPressure": "Minimum lufttrykk",
  "reports.minPressureMagnitude24h": "Minste forskjell (/24t)",
  "reports.minTemperature": "Minimumstemperatur",
  "reports.minTempMagnitude24h": "Minste forskjell (/24t)",
  "reports.monthlyHeatingEfficiency": "Månedlig oppvarmingseffektivitet",
  "reports.monthlyIndoorReport": "Månedlig innendørsrapport",
  "reports.monthlyOutdoorReport": "Månedlig utendørsrapport",
  "reports.monthlyReport": "Månedlig rapport",
  "reports.monthlySolarReport": "Månedlig solrapport",
  "reports.monthlyWindReport": "Månedlig vindrapport",
  "reports.numberOfDays": "Antall dager",
  "reports.outdoorReport": "Utendørsrapport",
  "reports.rainfall": "Nedbør",
  "reports.rainyDays": "Dager med regn",
  "reports.relativelyWet": "Relativt vått (60% {lessThan} Fuktighet ≤ 80%)",
  "reports.sendEmail": "Send E-post",
  "reports.tooDry": "For tørt (Fuktighet ≤ 45%)",
  "reports.tooWet": "For vått (Fuktighet {greaterThan} 80%)",
  "reports.tropicalNights": "Tropiske netter",
  "reports.waterBalance": "Vannbalanse",
  "reports.yearToDateTemperature": "Temperatur hittil i år",
  "reports.yearToDateTemperatureComparison": "Sammenligning av temperatur hittil i år",
  "sensors.aqiByChannel": "AQI per kanal",
  "sensors.bgtSensors": "Svartkule & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareAqi": "Sammenlign AQI",
  "sensors.compareHumidity": "Sammenlign fuktighet",
  "sensors.compareMoisture": "Sammenlign jordfuktighet",
  "sensors.comparePm25": "Sammenlign PM2.5",
  "sensors.compareTemperatures": "Sammenlign temperaturer",
  "sensors.depthByChannel": "Dybde per kanal",
  "sensors.heatStressExtreme": "Ekstrem varmestress",
  "sensors.heatStressModerate": "Moderat varmestress",
  "sensors.heatStressNone": "Ingen varmestress",
  "sensors.heatStressStrong": "Sterk varmestress",
  "sensors.heatStressVeryStrong": "Svært sterk varmestress",
  "sensors.humidityByChannel": "Fuktighet per kanal",
  "sensors.indoorAirQuality": "Innendørs luftkvalitet",
  "sensors.indoorAirQualityPm": "PM2.5 og PM10 AQI",
  "sensors.indoorClimate": "Inneklima",
  "sensors.indoorCo2Levels": "CO2-nivåer",
  "sensors.indoorTemperatureAndHumidity": "Temperatur og fuktighet",
  "sensors.last24Hours": "24 timer",
  "sensors.last30Days": "30 dager",
  "sensors.last7Days": "7 dager",
  "sensors.leafTemperatureByChannel": "Bladtemperatur per kanal",
  "sensors.leafWetnessByChannel": "Bladfuktighet per kanal",
  "sensors.lightningSensor": "Lyn",
  "sensors.moistureByChannel": "Jordfuktighet per kanal",
  "sensors.noDataAvailable": "Ingen data tilgjengelig",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 per kanal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Velg kanal",
  "sensors.sensorDetailDescription": "Se historiske data og trender for sensorkanalene dine.",
  "sensors.sensorHistory": "Sensorhistorikk",
  "sensors.soilConductivityByChannel": "Ledningsevne per kanal",
  "sensors.soilTemperatureByChannel": "Jordtemperatur per kanal",
  "sensors.strikesToday": "Nedslag i dag",
  "sensors.temperatureByChannel": "Temperatur per kanal",
  "settings.about": "Om",
  "settings.aboutDescription": "Lisensavtale, personvernerklæring",
  "settings.account": "Konto",
  "settings.accountDescription": "Profil, endring av passord",
  "settings.accountIntro": "Data angående kontoen din:",
  "settings.accountSection": "Konto",
  "settings.appearance": "Utseende",
  "settings.appearanceDescription": "Tema og visningsalternativer",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arabisk",
  "settings.availableServices": "Tilgjengelig",
  "settings.bulgarian": "Bulgarsk",
  "settings.cannotDisconnectLastAccount": "Kan ikke koble fra din eneste påloggingsmetode. Legg til en annen påloggingsmetode først.",
  "settings.changeEmail": "Endre e-post",
  "settings.changePassword": "Bytt passord",
  "settings.chartGestures": "Bevegelser på diagrammer",
  "settings.chartGesturesDescription": "Sveiping på diagrammer endrer tidsperioden, kniping på diagrammer endrer tidsskala",
  "settings.connect": "Koble til",
  "settings.connected": "Tilkoblet",
  "settings.connectedAccounts": "Tilknyttede kontoer",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Tilkoblet",
  "settings.connectedSince": "Tilkoblet siden {date}",
  "settings.connectionSuccess": "{provider}-konto tilkoblet",
  "settings.contactUs": "Kontakt oss",
  "settings.contactUsDescription": "Få hjelp eller send tilbakemelding",
  "settings.croatian": "Kroatisk",
  "settings.currentPassword": "Nåværende passord",
  "settings.czech": "Tsjekkisk",
  "settings.danish": "Dansk",
  "settings.dark": "Mørkt tema",
  "settings.dataDisplay": "Datavisning",
  "settings.dateAndTime": "Dato og tid",
  "settings.disconnect": "Koble fra",
  "settings.disconnectConfirmation": "Er du sikker på at du vil koble fra {provider}-kontoen din?",
  "settings.disconnectionSuccess": "{provider}-konto frakoblet",
  "settings.donateButton": "Gi en donasjon",
  "settings.donateDescription": "SmartMixin er laget av et lite team. Hvis du har nytte av den, kan du støtte utviklingen med en engangsdonasjon på et hvilket som helst beløp. Det er en gave — den endrer ikke abonnementet ditt og låser ikke opp noen funksjoner.",
  "settings.donateSuccessBody": "Donasjonen din bidrar til å holde SmartMixin i gang og gjøre den bedre. Vi setter stor pris på det.",
  "settings.donateSuccessTitle": "Takk for støtten!",
  "settings.donateTitle": "Støtt SmartMixin",
  "settings.dutch": "Nederlandsk",
  "settings.emailChange": "Endre e-postadresse",
  "settings.emailChangeConfirmation": "Bekreftelse av e-postendring",
  "settings.emailChangeFailure": "Lenken for e-postendring er ugyldig eller har utløpt.",
  "settings.emailChangeSuccess": "E-postadressen din er endret til {newEmail}.",
  "settings.emailChangeVerificationSent": "En bekreftelses-e-post er sendt til din nye e-postadresse. Sjekk innboksen din og klikk på lenken for å bekrefte endringen.",
  "settings.english": "Engelsk",
  "settings.forecastModelOrderEmpty": "Ingen rekkefølge lagret — vi bruker GFS som standard.",
  "settings.forecastModelOrderFreeHint": "Premium-modeller krever et SmartMixin Premium-abonnement.",
  "settings.forecastModelOrderHelp": "Vi velger den første modellen i listen som dekker hver stasjon.",
  "settings.forecastModelOrderReset": "Tilbakestill",
  "settings.forecastModelOrderTitle": "Standard værmodell",
  "settings.forecastModels": "Værmodeller",
  "settings.forecastModelsDescription": "Endre rekkefølgen etter preferanse",
  "settings.french": "Fransk",
  "settings.german": "Tysk",
  "settings.gestures": "Bevegelser",
  "settings.greek": "Gresk",
  "settings.helpCenter": "Hjelpesenter",
  "settings.helpCenterDescription": "Vanlige spørsmål og veiledninger",
  "settings.hungarian": "Ungarsk",
  "settings.integrationsSection": "Integrasjoner",
  "settings.italian": "Italiensk",
  "settings.japanese": "japansk",
  "settings.korean": "koreansk",
  "settings.language": "Språk",
  "settings.languageDescription": "Foretrukket Språk",
  "settings.light": "Lyst tema",
  "settings.newEmailAddress": "Ny e-postadresse",
  "settings.newPassword": "Nytt passord",
  "settings.newPasswordAgain": "Gjenta nytt passord",
  "settings.norwegian": "Norsk",
  "settings.notConnected": "Ikke tilkoblet",
  "settings.notificationsSection": "Varsler",
  "settings.oldPassword": "Gammelt passord",
  "settings.ongoingNotificationEnabled": "Aktiver permanent varsel",
  "settings.ongoingNotificationMetrics": "Viste målinger",
  "settings.ongoingNotificationMetricsHint": "Dra for å omorganisere valgte målinger",
  "settings.ongoingNotificationPermissionRequired": "Varslingstillatelse kreves",
  "settings.ongoingNotificationStation": "Værstasjon",
  "settings.passwordChange": "Endring av passord",
  "settings.polish": "Polsk",
  "settings.portuguese": "Portugisisk",
  "settings.preferencesSection": "Innstillinger",
  "settings.premium": "Premium",
  "settings.premiumActive": "Aktiv",
  "settings.premiumAnnualThenPrice": "Deretter 9,99 €/år",
  "settings.premiumAnnualTrialInfo": "Start med en gratis prøveperiode på {days} dager",
  "settings.premiumCurrentPlan": "Current Plan",
  "settings.premiumDescription": "Lås opp Premium funksjoner",
  "settings.premiumDownloadApp": "Download the app to subscribe:",
  "settings.premiumExpiresOn": "Renews on {date}",
  "settings.premiumFreePlan": "Free",
  "settings.premiumInactive": "Ikke abonnert",
  "settings.premiumManageWebSubscription": "Administrer abonnementet ditt, oppdater betalingsmetode eller avbryt.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Årlig — 9,99 €/år",
  "settings.premiumSubscribedOn": "Subscribed on {platform}",
  "settings.premiumSubscribeMonthly": "Månedlig — 1,99 €/måned",
  "settings.premiumSubscribeOnWeb": "Abonner nå for å låse opp alle premium-funksjoner.",
  "settings.premiumSubscriptionSuccess": "Abonnementet ditt er aktivert! Nyt alle premium-funksjoner.",
  "settings.premiumSubscriptionSuccessTitle": "Velkommen til Premium!",
  "settings.premiumWebappNotice": "Subscriptions can only be purchased through the SmartMixin mobile app on iOS or Android.",
  "settings.privacyPolicy": "Personvernerklæring",
  "settings.profile": "Profil",
  "settings.russian": "russisk",
  "settings.serbian": "Serbisk",
  "settings.settings": "Innstillinger",
  "settings.slovak": "Slovakisk",
  "settings.smallDecimals": "Små desimaler",
  "settings.smallDecimalsDescription": "Vis desimaltall i en mindre størrelse",
  "settings.socialConnectionsIntro": "Koble til dine sosiale kontoer for rask pålogging. Du kan koble til eller fra kontoer når som helst.",
  "settings.spanish": "Spansk",
  "settings.statusBarWidget": "Statuslinje-widget",
  "settings.statusBarWidgetDescription": "Alltid synlige værdata",
  "settings.subscriptionSection": "Abonnement",
  "settings.supportSection": "Støtte",
  "settings.swedish": "Svensk",
  "settings.systemTheme": "Systemtema",
  "settings.termsOfService": "Vilkår for bruk",
  "settings.turkish": "Tyrkisk",
  "settings.ukrainian": "ukrainsk",
  "settings.units": "Enheter",
  "settings.unitsDescription": "Måleenheter som benyttes i appen",
  "settings.update": "Oppdater",
  "settings.updateYourProfile": "Oppdater profilen din",
  "settings.weatherServices": "Værtjenester",
  "settings.weatherServicesConnected": "{count, plural, =0 {Ingen tjenester tilkoblet} one {# tjeneste tilkoblet} other {# tjenester tilkoblet}}",
  "settings.weatherServicesDescription": "Koble til Netatmo, Davis, Weatherflow og mer",
  "settings.windDirectionConvention": "Vindretningspil",
  "settings.windDirectionConventionDescription": "Velg hvordan vindretningspiler vises",
  "settings.windDirectionMeteorological": "Opprinnelsesretning",
  "settings.windDirectionMeteorologicalDescription": "Pilen viser hvor vinden kommer fra (meteorological konvensjon)",
  "settings.windDirectionOceanographic": "Strømningsretning",
  "settings.windDirectionOceanographicDescription": "Pilen viser hvor vinden blåser (oceanographic konvensjon)",
  "units.absolutePressure": "Absolutt trykk",
  "units.airDensity": "Lufttetthet",
  "units.airGap": "Luftspalte",
  "units.apparentTemperature": "Følt temperatur",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Gj. snitt",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Svartkuletemperatur",
  "units.boilerOn": "Kjele På",
  "units.co2": "CO2",
  "units.conductivity": "Ledningsevne",
  "units.coolingDegreeDays": "Cooling degree days",
  "units.dailyHeatingDuration": "Daglig oppvarmingsvarighet",
  "units.dailyPrecipitation": "Daglig nedbør",
  "units.dailyRain": "Daglig nedbør",
  "units.degreeDay": "Grad dag",
  "units.degreeDayShort": "DD",
  "units.depth": "Dybde",
  "units.depthSensors": "Dybdesensorer",
  "units.dewPoint": "Duggpunkt",
  "units.distance": "Distanse",
  "units.downTrend": "ned",
  "units.E": "Ø",
  "units.E_long": "Øst",
  "units.ENE": "ØNØ",
  "units.ENE_long": "Øst-Nordøst",
  "units.ESE": "ØSØ",
  "units.ESE_long": "Øst-Sørøst",
  "units.ET": "Evapotranspirasjon",
  "units.ETshort": "ET",
  "units.feelLike": "Følt temperatur",
  "units.feelsLike": "Følt temperatur",
  "units.footMile": "Fot, Mile",
  "units.frostPoint": "Frostpunkt",
  "units.gust": "Vindkast",
  "units.heatIndex": "Varmeindeks",
  "units.heatingDegreeDays": "Heating degree days",
  "units.heatingPower": "Varmekraft",
  "units.humidex": "Humidex",
  "units.humidity": "Luftfuktighet",
  "units.inch": "Tommer",
  "units.inchOfMercury": "Tommer kvikksølv",
  "units.kilometerPerHour": "Kilometer i timen",
  "units.knot": "Knop",
  "units.last12Hours": "Siste 12 timer",
  "units.last24Hours": "Siste 24 timer",
  "units.last3Hours": "Siste 3 timer",
  "units.last6Hours": "Siste 6 timer",
  "units.lastHour": "Siste time",
  "units.lastLightningImpact": "Siste innvirkning",
  "units.lastMeasure": "Siste måling",
  "units.leafSensors": "Bladsensorer",
  "units.leafWetness": "Bladfuktighet",
  "units.lightningDistance": "Distanse",
  "units.lightningStrikeCount": "Lyn teller",
  "units.lightningStrikeDistance": "Lyn avstand",
  "units.max": "Maks.",
  "units.max_gust": "Maks. vindkast",
  "units.max_wind": "Maks. vind",
  "units.meterKilometer": "Meter, kilometer",
  "units.meterPerSecond": "Meter per sekund",
  "units.milePerHour": "Mile per time",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimeter",
  "units.millimeterOfMercury": "Millimeter kvikksølv",
  "units.min": "Min.",
  "units.N": "N",
  "units.N_long": "Nord",
  "units.NE": "NØ",
  "units.NE_long": "Nordøst",
  "units.NNE": "NNØ",
  "units.NNE_long": "Nord-Nordøst",
  "units.NNW": "NNV",
  "units.NNW_long": "Nord-Nordvest",
  "units.noise": "Støy",
  "units.normalizedHeatingCoefficient": "Normalisert oppvarmingskoeffisient",
  "units.NW": "NV",
  "units.NW_long": "Nordvest",
  "units.O3": "Oson",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Nedbør",
  "units.pressure": "Lufttrykk",
  "units.rain": "Regn",
  "units.rainRate": "Regnintensitet",
  "units.referenceTemperature": "Referansetemperatur",
  "units.relativePressure": "Relativt trykk",
  "units.S": "S",
  "units.S_long": "Sør",
  "units.SE": "SØ",
  "units.SE_long": "Sørøst",
  "units.setPoint": "Settpunkt",
  "units.snow": "Snø",
  "units.snowfall": "Snøfall",
  "units.soilMoisture": "Fuktighet",
  "units.soilSensors": "Jordsensorer",
  "units.solarEnergy": "Solenergi",
  "units.solarRadiation": "Solstråling",
  "units.speed": "Hastighet",
  "units.SSE": "SSØ",
  "units.SSE_long": "Sør-Sørøst",
  "units.SSW": "SSV",
  "units.SSW_long": "Sør-Sørvest",
  "units.stableTrend": "stabil",
  "units.sum": "Sum",
  "units.SW": "SV",
  "units.SW_long": "Sørvest",
  "units.temperature": "Temperatur",
  "units.temperatureAndHumiditySensors": "Temperatur- og fuktighetssensorer",
  "units.temperatureSensors": "Temperatur- og fuktighetssensorer",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "I dag",
  "units.upTrend": "opp",
  "units.uv": "UV",
  "units.visibility": "Sikt",
  "units.W": "V",
  "units.W_long": "Vest",
  "units.wetBulbGlobeTemperature": "Våtkuletemperatur (Wet bulb globe)",
  "units.wetBulbTemperature": "Våttemperatur (Wet bulb)",
  "units.wind": "Vind",
  "units.windChill": "Vindavkjøling",
  "units.windDirection": "Vindretning",
  "units.windRun": "Vinddistanse",
  "units.windRunDescription": "Vinddistanse er den totale avstanden vinden tilbakelegger over en tidsperiode",
  "units.WNW": "VNV",
  "units.WNW_long": "Vest-Nordvest",
  "units.WSW": "VSV",
  "units.WSW_long": "Vest-Sørvest"
}
